export default {
  path: 'banking',
  name: 'savings-banking',
  component: () => import('./banking.vue'),
  meta: {
    permissions: {
      roles: ['user'],
      redirectTo: {
        name: 'login'
      }
    }
  }
}
